<p>
  trimrender works!
</p>
